import React from 'react'
import { DataTable } from '@paypalcorp/pp-react'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const allRows = [
  {
    id: 'row1',
    testName: {
      value: 'Card refused',
    },
    trigger: {
      value: 'CCREJECT-REFUSED',
    },
    procRespCode: {
      value: '0500',
    },
    codeDesc: {
      value: 'DO_NOT_HONOR',
    },
  },
  {
    id: 'row2',
    testName: {
      value: 'Fraudulent card',
    },
    trigger: {
      value: 'CCREJECT-SF',
    },
    procRespCode: {
      value: '9500',
    },
    codeDesc: {
      value:
        'SUSPECTED_FRAUD. Try using another card. Do not retry the same card.',
    },
  },
  {
    id: 'row3',
    testName: {
      value: 'Card expired',
    },
    trigger: {
      value: 'CCREJECT-EC',
    },
    procRespCode: {
      value: '5400',
    },
    codeDesc: {
      value: 'EXPIRED_CARD',
    },
  },
  {
    id: 'row4',
    testName: {
      value: 'Luhn Check fails',
    },
    trigger: {
      value: 'CCREJECT-IRC',
    },
    procRespCode: {
      value: '5180',
    },
    codeDesc: {
      value:
        'INVALID_OR_RESTRICTED_CARD. Try using another card. Do not retry the same card.',
    },
  },
  {
    id: 'row5',
    testName: {
      value: 'Insufficient funds',
    },
    trigger: {
      value: 'CCREJECT-IF',
    },
    procRespCode: {
      value: '5120',
    },
    codeDesc: {
      value: 'INSUFFICIENT_FUNDS',
    },
  },
  {
    id: 'row6',
    testName: {
      value: 'Card lost, stolen',
    },
    trigger: {
      value: 'CCREJECT-LS',
    },
    procRespCode: {
      value: '9520',
    },
    codeDesc: {
      value:
        'LOST_OR_STOLEN. Try using another card. Do not retry the same card.',
    },
  },
  {
    id: 'row7',
    testName: {
      value: 'Card not valid',
    },
    trigger: {
      value: 'CCREJECT-IA',
    },
    procRespCode: {
      value: '1330',
    },
    codeDesc: {
      value: 'INVALID_ACCOUNT',
    },
  },
  {
    id: 'row8',
    testName: {
      value: 'Card is declined',
    },
    trigger: {
      value: 'CCREJECT-BANK_ERROR',
    },
    procRespCode: {
      value: '5100',
    },
    codeDesc: {
      value: 'GENERIC_DECLINE',
    },
  },
  {
    id: 'row9',
    testName: {
      value: 'CVC check fails',
    },
    trigger: {
      value: 'CCREJECT-CVV_F',
    },
    procRespCode: {
      value: '00N7',
    },
    codeDesc: {
      value: 'CVV2_FAILURE_POSSIBLE_RETRY_WITH_CVV',
    },
  },
]

const columns = {
  testName: {
    title: 'Test name',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  trigger: {
    title: 'Trigger',
    cellAs: CodeCell,
    mobile: {
      placement: 'b3',
    },
  },
  procRespCode: {
    title: 'Processor response code',
    cellAs: CodeCell,
    mobile: {
      placement: 'b3',
    },
  },
  codeDesc: {
    title: 'Code description',
    cellAs: CodeCell,
    mobile: {
      placement: 'b3',
    },
  },
}

const RejectionTriggersTable = () => {
  return (
    <>
      <DataTable
        description="Basic"
        rows={allRows}
        columns={columns}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
    </>
  )
}

export default RejectionTriggersTable
